<div class="row mb-4">
  <div class="col-2 col-md-3">
    <button
      class="btn bg-white border mb-2"
      id="toggleViewBtn"
      (click)="toggleSwitch()"
    >
      <i-feather
        name="{{ view ? 'list' : 'grid' }}"
        class="small-icon"
      ></i-feather>
    </button>
  </div>
  @if (!show && showFilter) {
  <div class="col-md-3">
    <div class="row">
      <ng-select
        [(ngModel)]="customerId"
        (ngModelChange)="searchUser()"
        [clearable]="false"
      >
        <ng-option value="" selected>Alle klanten</ng-option>
        @for (c of customers; track c) {
        <ng-option [value]="c._id">{{ c.name }}</ng-option>
        }
      </ng-select>
      <div class="input-group-append">
        <span
          class="input-group-text"
          id="filter-addon"
          (click)="filterProjects.emit(true)"
        >
          <i-feather name="filter" class="small-icon"></i-feather>
        </span>
      </div>
    </div>
  </div>
  } @else {
  <div class="col-10 col-md-3"></div>
  }

  <div class="col-md-3">
    <div class="row">
      <ng-select
        [(ngModel)]="sort"
        (ngModelChange)="searchUser()"
        [clearable]="false"
      >
        @if (type === 'SEALS') {
        <ng-option value="Code A-Z">Code A-Z</ng-option>
        } @if (type !== 'SEALS') {
        <ng-option value="Naam A-Z">Naam A-Z</ng-option>
        } @for (s of sortList; track s) {
        <ng-option [value]="s">{{ s }}</ng-option>
        }
      </ng-select>
      <div class="input-group-append">
        @if (type !== 'SEALS') {
        <span class="input-group-text" id="sort-addon">
          <i-feather name="bar-chart-2" class="small-icon"></i-feather>
        </span>
        } @if (type === 'SEALS') {
        <span
          (click)="filterSeals.emit(true)"
          class="input-group-text filter-button"
          id="btn-filter"
        >
          <i-feather name="filter"></i-feather>
        </span>
        }
      </div>
    </div>
  </div>

  <div class="col-10 col-md-3">
    <div class="input-group mb-2">
      <input
        type="text"
        class="form-control"
        data-testid="search-input-field"
        id="search-input-field"
        [(ngModel)]="search"
        (keyup)="searchUser(search)"
        placeholder="{{ searchPlaceholder }}"
        aria-label="search"
        aria-describedby="search"
      />
      @if (search === '') {
      <div class="input-group-append">
        <span class="input-group-text" id="search-addon">
          <i-feather name="search" class="small-icon"></i-feather>
        </span>
      </div>
      } @if (search != '') {
      <div
        class="input-group-append hover"
        (click)="search = ''; searchUser(search)"
      >
        <span class="input-group-text" id="search-addon">
          <i-feather name="x" class="small-icon"></i-feather>
        </span>
      </div>
      }
    </div>
  </div>
</div>
